import config from '../../../config';
import { calculQuota as calculQuotaCastellarnau, MostraQuota as MostraQuotaCastellarnau, setCataleg as setCatalegCastellarnau } from './quotes.castellarnau';
import { calculQuota as calculQuotaJoanOro, MostraQuota as MostraQuotaJoanOro, setCataleg as setCatalegJoanOro } from './quotes.joanoro';
import { calculQuota as calculQuotaCavallBernat, MostraQuota as MostraQuotaCavallBernat, setCataleg as setCatalegCavallBernat } from './quotes.cavallbernat';
import { calculQuota as calculQuotaPompeuFabra, MostraQuota as MostraQuotaPompeuFabra, setCataleg as setCatalegPompeuFabra } from './quotes.pompeufabra';
import { calculQuota as calculQuotaJaumeMimo, MostraQuota as MostraQuotaJaumeMimo, setCataleg as setCatalegJaumeMimo } from './quotes.jaumemimo';
import { calculQuota as calculQuotaArtLaIndustrial, MostraQuota as MostraQuotaArtLaIndustrial, setCataleg as setCatalegArtLaIndustrial } from './quotes.artlaindustrial';
import { calculQuota as calculQuotaIBadia, MostraQuota as MostraQuotaIBadia, setCataleg as setCatalegIBadia } from './quotes.ibadia';
import { calculQuota as calculQuotaSantaEulalia, MostraQuota as MostraQuotaSantaEulalia, setCataleg as setCatalegSantaEulalia } from './quotes.santaeulalia';
import { calculQuota as calculQuotaDemo, MostraQuota as MostraQuotaDemo, setCataleg as setCatalegDemo } from './quotes.demo';

export function calculQuota(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre )
{
  switch(config.cid)
  {
     // Joan Oro
   case 'a8037152': 
   return calculQuotaJoanOro(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );
   
   // Castellarnau
   case 'a8024893': 
   return calculQuotaCastellarnau(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

     // Cavall Bernat
   case 'a8053251': 
   return calculQuotaCavallBernat(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

     // Pompeu Fabra
   case 'a8020620': 
   return calculQuotaPompeuFabra(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

     // Jaume Mimó
   case 'a8044715': 
   return calculQuotaJaumeMimo(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

     //  Art La Industrial
   case 'a8042354': 
   return calculQuotaArtLaIndustrial(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

     //  IBadia
   case 'a8042342': 
   return calculQuotaIBadia(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

     //  Santa Eulàlia
   case 'a8043516':
   return calculQuotaSantaEulalia(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

     // DEMO
   case 'demo':
   return calculQuotaDemo(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre );

   default: //error
  }
}

// injecta el catàleg d'assignatures i les dades bancàries (carregades via API a
// studies.*.js) al mòdul de quotes del centre actiu; els altres 7 queden sense
// actualitzar, però mai s'invoquen perquè config.cid només selecciona un d'ells
export function setCataleg(assignaturesCatalog, dadesbancaries)
{
  switch(config.cid)
  {
     // Joan Oro
   case 'a8037152':
   return setCatalegJoanOro(assignaturesCatalog, dadesbancaries)

   // Castellarnau
   case 'a8024893':
   return setCatalegCastellarnau(assignaturesCatalog, dadesbancaries)

     // Cavall Bernat
   case 'a8053251':
   return setCatalegCavallBernat(assignaturesCatalog, dadesbancaries)

     // Pompeu Fabra
   case 'a8020620':
   return setCatalegPompeuFabra(assignaturesCatalog, dadesbancaries)

     // Jaume Mimó
   case 'a8044715':
   return setCatalegJaumeMimo(assignaturesCatalog, dadesbancaries)

     //  Art La Industrial
   case 'a8042354':
   return setCatalegArtLaIndustrial(assignaturesCatalog, dadesbancaries)

     //  IBadia
   case 'a8042342':
   return setCatalegIBadia(assignaturesCatalog, dadesbancaries)

     //  Santa Eulàlia
   case 'a8043516':
   return setCatalegSantaEulalia(assignaturesCatalog, dadesbancaries)

     // DEMO
   case 'demo':
   return setCatalegDemo(assignaturesCatalog, dadesbancaries)

   default: //error
  }
}

export function MostraQuota(props)
{

  switch(config.cid)
  {
     // Joan Oro
   case 'a8037152': 
    return MostraQuotaJoanOro(props)

     // Castellarnau
   case 'a8024893': 
    return MostraQuotaCastellarnau(props)

     // Cavall Bernat
   case 'a8053251': 
    return MostraQuotaCavallBernat(props)

     // Pompeu Fabra
   case 'a8020620': 
    return MostraQuotaPompeuFabra(props)

     // Jaume Mimó
   case 'a8044715': 
    return MostraQuotaJaumeMimo(props)

     //  Art La Industrial
   case 'a8042354': 
    return MostraQuotaArtLaIndustrial(props)

     //  IBadia
   case 'a8042342': 
    return MostraQuotaIBadia(props)

     //  Santa Eulàlia
   case 'a8043516':
    return MostraQuotaSantaEulalia(props)

     // DEMO
   case 'demo':
    return MostraQuotaDemo(props)

   default: //error
  }
}